import {
  Colors,
  DeleteModal,
  IcAccount,
  IcImage,
  IcLink,
  IcPassword,
} from 'basic-ui-lib';
import styled from 'styled-components';
import MenuItem from './MenuItem';
import { useNavigate } from 'react-router-dom';
// import { useAppDispatch } from 'store/hooks';
import toast from 'utils/toast';
import { useState } from 'react';

const menuItems = [
  [
    {
      icon: <IcAccount width={16} height={16} />,
      label: 'Account Information',
      path: '/setting/profile',
    },
    {
      icon: <IcPassword width={16} height={16} />,
      label: 'Change Password',
      path: '/setting/change-password',
    },
  ],
  [
    {
      icon: <IcImage width={16} height={16} />,
      label: 'Media',
      path: '/media',
    },
    {
      icon: <IcLink width={16} height={16} />,
      label: 'Links',
      path: '/setting/links',
    },
  ],
];
const MenuSection = () => {
  const navigate = useNavigate();
  const [isLogoutModal, setIsLogoutModal] = useState(false);
  // const dispatch = useAppDispatch();
  
  // const handleOpenLogoutModal = () => {
  //   setIsLogoutModal(true);
  // };

  const handleCloseLogoutModal = () => {
    setIsLogoutModal(false);
  };

  const handleLogout = () => {
    // dispatch(authActions.logout());
    navigate('/login');
    toast.success('Logout successful');
  };
  return (
    <Container>
      {menuItems.map((group, index) => (
        <Content key={index}>
          {group.map((item) => (
            <MenuItem
              key={item.label}
              icon={item.icon}
              label={item.label}
              onClick={() => navigate(item.path)}
            />
          ))}
        </Content>
      ))}
      <DeleteModal
        isOpen={isLogoutModal}
        description='Bạn có chắc chắn muốn đăng xuất khỏi tài khoản này không?'
        onClose={handleCloseLogoutModal}
        onConfirm={handleLogout}
        labelConfirm='Xác nhận'
        labelCancel='Hủy'
      />
    </Container>
  );
};

export default MenuSection;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10);
  padding: 12px;
  border-radius: 12px;
  background-color: ${Colors.neutral.bg[1]};
`;
